import { useStrapiHeader } from './useStrapiHeader';
import { HeaderDiscount } from '@/types/header';

interface UseCategoryDiscountsReturn {
  discounts: HeaderDiscount[];
  isLoading: boolean;
  error: string | null;
}

export const useCategoryDiscounts = (categoryId: number, categoryName?: string): UseCategoryDiscountsReturn => {
  const { getCategoryDiscounts, loading, error } = useStrapiHeader();
  
  const discounts = getCategoryDiscounts(categoryId, categoryName);
  
  return { 
    discounts, 
    isLoading: loading, 
    error 
  };
};
